import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const CollegeWorkshops = () => (
  <div className="mb-5">
    <h2 className="text-primary">Workshops for College Students</h2>
    <ul className="list-group list-group-flush">
      <li className="list-group-item"><strong>Career Development:</strong> Skill development sessions including Personality Development, Resume Building, Interview Skills, Corporate Etiquettes, Interpersonal Relationships, Professional Networking, and Internships.</li>
      <li className="list-group-item"><strong>E Classes:</strong> Mathematics, Science, Social Science, and other academic subjects.</li>
      <li className="list-group-item"><strong>E-Tech Smart Classes:</strong> Communication and Presentation Skills, Graphic Design, Resume Building, Interview Skills, Interpersonal Relations, and Personality Development.</li>
      <li className="list-group-item"><strong>Fun And Learn:</strong> Sport activities combined with learning.</li>
    </ul>
  </div>
);

const SchoolWorkshops = () => (
  <div className="mb-5">
    <h2 className="text-success">Workshops for School Students</h2>
    <ul className="list-group list-group-flush">
      <li className="list-group-item"><strong>Computer Skills:</strong> Documentation, Data Analysis, Presentations, Poster Designing, and Google features.</li>
      <li className="list-group-item"><strong>MS Excel:</strong> Overview of Excel, Formatting, Relevant Formulae, Lookup Formulae, Subtotal, Tables, Pivot Tables, Graphs, and Charts.</li>
      <li className="list-group-item"><strong>Girl Empowerment:</strong> Topics include Health & Nutrition, Yoga & Stress Management, Constitutional Law for Women, Self Protection, Digital Transformation & Cybercrime, and Financial Management.</li>
      <li className="list-group-item"><strong>Content Writing:</strong> Introduction to content writing, Types of Writing, Creative Content, Writing Tips, SEO, Paraphrasing, Proofreading, Plagiarism tools, Brochures, Copywriting, and Blogging.</li>
      <li className="list-group-item"><strong>Digital Marketing:</strong> Social Media Marketing, Google Marketing, Lead Generation, Local SEO, Email Marketing, SEO & Personal Branding, Instagram Marketing, Brand Management, and Consumer Psychology.</li>
    </ul>
  </div>
);

const SeniorCitizenWorkshops = () => (
  <div className="mb-5">
    <h2 className="text-warning">Workshops for Senior Citizens</h2>
    <ul className="list-group list-group-flush">
      <li className="list-group-item">Sharing fond childhood memories.</li>
      <li className="list-group-item">hobbies and aspirations.</li>
      <li className="list-group-item">Experiences and anecdotes that shaped their lives or had a lasting impact on them.</li>
      <li className="list-group-item">Since how long are they here and under what circumstances- a brief life history.</li>
      <li className="list-group-item">Words of advice for youngsters and things to learn from them.</li>
    </ul>
  </div>
);

const HomemakerWorkshops = () => (
  <div className="mb-5">
    <h2 className="text-danger">Workshops for Homemakers</h2>
    <ul className="list-group list-group-flush">
      <li className="list-group-item"><strong>Smiling Tiffin:</strong>  Innovative tiffin ideas to ensure kids finish their meals.</li>
      <li className="list-group-item"><strong>Kitchen Farming:</strong> Growing herbs and vegetables organically, recycling kitchen waste.</li>
      <li className="list-group-item"><strong>Basic Digital Literacy:</strong> Managing social media accounts, email writing, etc.</li>
      <li className="list-group-item"><strong>Get Online:</strong> Online transactions, reservations, shopping, etc.</li>
      <li className="list-group-item"><strong> Chocolate Making:</strong> Fun treat for everyone.</li>
      <li className="list-group-item"><strong>Interior Decoration: </strong> Aesthetics, color combinations, and placement ideas.</li>
      <li className="list-group-item"><strong> Basic Home Maintenance: </strong>Repairing leaks, fixing bulbs, etc.</li>
      <li className="list-group-item"><strong> Doctor at Home:</strong> Home remedies for minor illnesses.</li>
      <li className="list-group-item"><strong> Creative Recycling:</strong> Recycling notebooks, plastic bottles, glass jars, old dresses, etc.</li>
      <li className="list-group-item"><strong> Getting Tech Savvy: </strong>Handling smartphones.</li>
      <li className="list-group-item"><strong> English Conversation:</strong> Simple daily conversations.</li>
      <li className="list-group-item"><strong> Basic Computer Skills: </strong>Office and Google applications.</li>
      <li className="list-group-item"><strong> Conservation Tips:</strong> Reducing electricity and gas usage to save costs and resources.</li>
      <li className="list-group-item"><strong> Household Tips:</strong> Pest control, cooking tips, budget management, etc.</li>
      <li className="list-group-item"><strong> online Teaching Education: </strong>OCorrespondence courses.</li>
      <li className="list-group-item"><strong> Improving Children's Concentration:</strong> Effective tips.</li>
      <li className="list-group-item">Editing Skills, Teaching, Fitness, Art and Craft, Financial Management, Time Management.</li>
    </ul>
  </div>
);

const CraftWorkshops = () => (
  <div className="mb-5">
    <h2 className="text-info">Workshops for Crafts</h2>
    <ul className="list-group list-group-flush">
      <li className="list-group-item"><strong> Hoop Art</strong></li>
      <li className="list-group-item"><strong> Painting</strong></li>
      <li className="list-group-item"><strong> DIY Projects</strong></li>
    </ul>
  </div>
);

const Participate = () => {
  const [topMargin, setTopMargin] = useState('8.5rem');

  useEffect(() => {
    // Function to handle responsive margin adjustment
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // Mobile view - reduce the top margin
        setTopMargin('0.5rem');
      } else {
        // Desktop view - keep original margin
        setTopMargin('8.5rem');
      }
    };

    // Set initial value
    handleResize();
    
    // Update on resize
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="container my-5">
      <div style={{ marginTop: topMargin }}></div>
      <CollegeWorkshops />
      <SchoolWorkshops />
      <SeniorCitizenWorkshops />
      <HomemakerWorkshops />
      <CraftWorkshops />
    </div>
  );
};

export default Participate;